import { ImageComparison } from '../components/ImageComparison';
import { ResponsiveImage } from '../components/ResponsiveImage';
import { Reveal } from '../components/Reveal';
import { projects } from '../data/content';
import { ProjectFacts } from '../components/ProjectFacts';

export function AsphaltPage() {
  const asphalt = projects.filter((project) => project.slug.startsWith('asfalto-'));
  return <>
    <section className="page-hero page-hero--project"><div className="shell page-hero__grid">
      <h1>Obras de <span>asfalto em Palmas.</span></h1>
      <div><p>Três frentes de pavimentação apresentadas no material cadastrado, com valores e escopos.</p></div>
    </div></section>
    <section className="asphalt-page shell">{asphalt.map((project) => <article id={project.slug} className="asphalt-project" key={project.slug}>
      <Reveal className="asphalt-project__copy">
        <h2>{project.title}</h2><p>{project.summary}</p>
        <ProjectFacts project={project} />
      </Reveal>
      <Reveal className="asphalt-project__media" delay={0.08}>
        {project.media.length === 2 ? <ImageComparison before={project.media[0]} after={project.media[1]} /> : <ResponsiveImage media={project.media[0]} sizes="(max-width: 800px) 100vw, 58vw" />}
      </Reveal>
    </article>)}</section>
  </>;
}
